import Globalize from "globalize";

export const format = Globalize.formatMessage.bind(Globalize);
export const formatMessage = Globalize.formatMessage.bind(Globalize);
export const formatNumber = Globalize.formatNumber.bind(Globalize);
export const formatCurrency = Globalize.formatCurrency.bind(Globalize);
export const formatDate = Globalize.formatDate.bind(Globalize);
export const numberParser = Globalize.numberParser.bind(Globalize);

export const getLocale = () => Globalize.cldr?.locale;

export function territories() {
    return Globalize.cldr.main("localeDisplayNames/territories");
}

export function states() {
    const states = Globalize.cldr.get("globalize-messages/{bundle}/states");
    const translatedTerritories = territories();
    // add overlooked territories, as if they didn't have enough problems.
    ["GU", "PR", "VI", "AS", "MP"].forEach((key) => {
        states[key] = translatedTerritories[key];
    });

    return states;
}

export const getCurrencyInfo = (currencyCode) => Globalize.cldr.main("numbers/currencies")[currencyCode];
